export default __webpack_public_path__ + "static/backstagesupport-header-40-3582db72664e6a3e4e0e2bfa6c3d3fff.png";